import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import PrepaidTicketContent from 'components/park/PrepaidTicketContent';
import ParkingContext from 'context/ParkingContext';
import useReadPurchasedPrepaidTickets from 'hooks/useReadPurchasedPrepaidTickets';
import React, { useContext, useEffect } from 'react';
import { ScrollView } from 'react-native';
import { WebContentWrapper } from 'screens/permit/styles';
import {
  parkingPaymentCardId,
  parkingVehicleLicensePlate,
} from 'states/common';
import { StyledWrapper } from 'styles/ContainerStyles';
import { PredefinedTicket } from 'types/generatedSchemaTypes';
import { ServicesStackParamList } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import { blockPaymentUsage } from 'utils/paymentUtils';
import { isItemPredefinedTicket, isItemSalesOrder } from 'utils/permitUtils';

const PrepaidTicketEdit: React.FC = () => {
  const { selectedParkzonePmcUnion } = useContext(ParkingContext);
  const {
    params: { ticketId },
  } = useRoute<RouteProp<ServicesStackParamList, 'prepaidEdit'>>();
  const { purchasedPrepaidTickets } = useReadPurchasedPrepaidTickets({
    fetchAll: true,
  });
  const getSessionId = () => {
    if (ticketId) {
      return ticketId;
    }
    if (isItemPredefinedTicket(selectedParkzonePmcUnion)) {
      return selectedParkzonePmcUnion.sessionId;
    }
  };
  const sessionId = getSessionId();
  const prepaidTicket = purchasedPrepaidTickets.find(
    (item) => item?.sessionId === sessionId
  );

  useFocusEffect(
    React.useCallback(() => {
      blockPaymentUsage('EDIT_PERMIT');
      return () => {
        blockPaymentUsage('');
      };
    }, [])
  );

  useFocusEffect(
    React.useCallback(() => {
      if (
        selectedParkzonePmcUnion &&
        isItemSalesOrder(selectedParkzonePmcUnion)
      ) {
        parkingVehicleLicensePlate(
          selectedParkzonePmcUnion?.orderLines?.find(Boolean)
            ?.registrationPlates?.[0]?.plateText || ''
        );
        blockPaymentUsage('EDIT_PERMIT');
      }
      return () => {
        parkingVehicleLicensePlate(undefined);
        blockPaymentUsage('');
      };
    }, [selectedParkzonePmcUnion])
  );

  useEffect(() => {
    if (
      selectedParkzonePmcUnion &&
      isItemSalesOrder(selectedParkzonePmcUnion)
    ) {
      parkingPaymentCardId(selectedParkzonePmcUnion.creditCardId || undefined);
      parkingVehicleLicensePlate(
        selectedParkzonePmcUnion?.orderLines?.find(Boolean)
          ?.registrationPlates?.[0]?.plateText || ''
      );
      return;
    }
    parkingVehicleLicensePlate(prepaidTicket?.accessDevice?.value || '');
  }, [prepaidTicket?.accessDevice?.value, selectedParkzonePmcUnion]);

  const testID = 'prepaid-ticket-edit';

  if (isWeb) {
    return (
      <ScrollView>
        <StyledWrapper center mt={50}>
          <WebContentWrapper>
            <PrepaidTicketContent
              type="edit"
              testID={testID}
              selectedPrepaidTicket={prepaidTicket as PredefinedTicket}
            />
          </WebContentWrapper>
        </StyledWrapper>
      </ScrollView>
    );
  }

  return (
    <PrepaidTicketContent
      type="edit"
      testID={testID}
      selectedPrepaidTicket={prepaidTicket as PredefinedTicket}
    />
  );
};

export default PrepaidTicketEdit;
